import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    heading: "We don't sell dreams.",
    body: "We engineer departures. Every application we file is preceded by 40+ hours of research on program fit, cost of living, and long-term visa outcomes.",
  },
  {
    n: "02",
    heading: "Your story is the strategy.",
    body: "SOP templates are dead. Our editors sit with you across three sessions to extract the one honest sentence around which your entire application will pivot.",
  },
  {
    n: "03",
    heading: "The consulate is not the enemy.",
    body: "Visa officers reward clarity. We rehearse until your interview answers become as ordinary as ordering coffee.",
  },
  {
    n: "04",
    heading: "We stay after you land.",
    body: "Bank accounts, SIM cards, first-week grocery runs, roommate mediation. You have a WhatsApp thread with your Edufly advisor for 12 months post-arrival.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative py-24 md:py-40 bg-[#0a192f] text-white overflow-hidden"
      data-testid="manifesto-section"
    >
      <div className="grain-dark absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <span className="section-label" style={{ color: "#00A3FF" }}>
              <span
                className="!bg-[#00A3FF]"
                style={{
                  display: "inline-block",
                  width: 28,
                  height: 1,
                  background: "#00A3FF",
                  marginRight: 8,
                }}
              ></span>
              CH · 03 / Manifesto
            </span>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-white text-4xl sm:text-5xl md:text-6xl tracking-[-0.025em] leading-[0.98]">
              Four principles we{" "}
              <span className="italic font-normal text-[#00A3FF]">
                refuse to negotiate.
              </span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-x-24 md:gap-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="grid grid-cols-[auto_1fr] gap-6 md:gap-10"
              data-testid={`manifesto-chapter-${i}`}
            >
              <div className="font-display text-6xl md:text-7xl font-bold text-[#00A3FF] leading-none">
                {c.n}
              </div>
              <div className="pt-1 border-t border-white/15">
                <h3 className="font-display text-2xl md:text-3xl mt-6 mb-4 tracking-tight leading-tight">
                  {c.heading}
                </h3>
                <p className="text-white/70 font-body leading-relaxed max-w-md">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
